import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../DatiSpecifici/DatiSpecifici.module.css";
import RadioButton from "../../../../../components/radiobutton/RadioButton";
import Calendar from "../../../../../components/calendar/Calendar";
import Utils from "../../../../../utils/Utils";
import Input from "../../../../../components/textbox/Input";

class Parte1B extends Component {

    state = {
        parte1B: {
            trattamento: "",
            annoTrattamento: "",
            indirizzoCentro: "",
            dataInizioTerapia: "",
            storiaMalattia: "",
            recidiva: ""
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloDati = this.controlloDati.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {

        let parte1B = this.state.parte1B
        let parte1BCopia = this.props.segnalazioneCopia.esitoTbcPolmonare && this.props.segnalazioneCopia.esitoTbcPolmonare.parte1B ?
            this.props.segnalazioneCopia.esitoTbcPolmonare.parte1B : ""
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.esitoTbcPolmonare && parte1BCopia) {
            for (let key in parte1B) {
                if (parte1B.hasOwnProperty(key) === parte1BCopia.hasOwnProperty(key)) {
                    if (key === "dataInizioTerapia") {
                        parte1B[key] = Utils.transformDateForFrontend(parte1BCopia[key])
                    } else {
                        parte1B[key] = parte1BCopia[key]
                    }
                } else {
                    parte1B[key] = ""
                }
            }
            this.setState({parte1B: parte1B})
        }
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloDati()
        this.props.createOggettoBeAndcontrolloCorrettezza("parte1B", oggettoBE, corretto)
    }

    validate() {
        if (this.state.parte1B.dataInizioTerapia && Utils.validateDate(this.state.parte1B.dataInizioTerapia, "Messages.DataInizioTerapeutica", "Messages.DataInizioTerapeuticaOdierna")) {
            return Utils.validateDate(this.state.parte1B.dataInizioTerapia, "Messages.DataInizioTerapeutica", "Messages.DataInizioTerapeuticaOdierna")
        }
        return ""
    }

    riceviValore(field, event) {
        let parte1B = this.state.parte1B
        parte1B[field] = event.target.value
        if (parte1B.trattamento !== "2") {
            parte1B.annoTrattamento = ""
        }
        if (parte1B.trattamento !== "3") {
            parte1B.indirizzoCentro = ""
        }
        if (parte1B.storiaMalattia !== "2") {
            parte1B.recidiva = ""
        }
        this.setState({parte1B: parte1B})
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloDati()
        this.props.createOggettoBeAndcontrolloCorrettezza("parte1B", oggettoBE, corretto, this.validate())
    }

    controlloDati() {
        let parte1B = this.state.parte1B
        let corretto = []

        if(!parte1B.dataInizioTerapia || (parte1B.dataInizioTerapia && Utils.isDateInValid(Utils.transformDateForBackend(parte1B.dataInizioTerapia), "-"))) corretto[0] = "Campo \"Data inizio del presente episodio terapeutico\" mancante o errato";
        if(!parte1B.trattamento || (parte1B.trattamento === "2" && !parte1B.annoTrattamento) || (parte1B.trattamento === "3" && !parte1B.indirizzoCentro)) corretto[1] = "Campo \"Trattamento Antitubercolare:*(selezionare solo una voce)\" mancante";
        if(!parte1B.storiaMalattia || (parte1B.storiaMalattia === "2" && !parte1B.recidiva)) corretto[2] = "Campo \"Storia della malattia:*(selezionare solo una voce)\" mancante";

        return corretto
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.parte1B))
        oggettoBE.dataInizioTerapia = Utils.transformDateForBackend(oggettoBE.dataInizioTerapia)
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    render() {

        const {t} = this.props

        const parte1B = (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("SchedaSpecialeTbcPolmonare.parte1B")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    <div>
                        <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                            {t("SchedaSpecialeTbcPolmonare.trattamento")}
                            <span className={styles.mandatoryColor}>*</span>
                            <span style={{color: "black", fontWeight: "normal"}}>
                            {t("SchedaSpecialeTbcPolmonare.selSoloUnaVoce")}
                        </span>
                        </p>
                        <RadioButton id={"primoTrattamento"}
                                     name={"trattamento"} label={t("SchedaSpecialeTbcPolmonare.primoTrattamento")}
                                     value={"1"}
                                     newRadio={true}
                                     style={{color: "black"}}
                                     onClick={this.riceviValore}
                                     checked={this.state.parte1B.trattamento === "1"}/>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"giaTrattato"}
                                             name={"trattamento"} label={t("SchedaSpecialeTbcPolmonare.giaTrattato")}
                                             value={"2"} onClick={this.riceviValore}
                                             newRadio={true}
                                             style={{color: "black"}}
                                             checked={this.state.parte1B.trattamento === "2"}/>
                            </div>
                            <div className={"col-lg-4"}>
                                <p className={styles.testo} style={{color: "black"}}>
                                    {t("SchedaSpecialeTbcPolmonare.annoTrattamento")}
                                    {this.state.parte1B.trattamento === "2" ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}
                                </p>
                            </div>
                            <div className={"col-lg-2"}>
                                <Input
                                    type={"number"}
                                    min="0"
                                    id={"annoTrattamento"}
                                    onChange={this.riceviValore}
                                    field={"annoTrattamento"}
                                    disabled={this.state.parte1B.trattamento !== "2" ? true : false}
                                    value={this.state.parte1B.annoTrattamento}
                                    placeholder={t("SchedaSpecialeTbcPolmonare.aaaa")}
                                />
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-lg-6"}>
                                <RadioButton id={"trasferito"}
                                             name={"trattamento"}
                                             label={t("SchedaSpecialeTbcPolmonare.trasferito")}
                                             value={"3"} onClick={this.riceviValore}
                                             newRadio={true}
                                             style={{color: "black"}}
                                             checked={this.state.parte1B.trattamento === "3"}/>
                            </div>
                            <div className={"col-lg-3"}>
                                <Input
                                    id={"indirizzoCentro"}
                                    required={this.state.parte1B.trattamento === "3" ? true : false}
                                    onChange={this.riceviValore}
                                    field={"indirizzoCentro"}
                                    disabled={this.state.parte1B.trattamento !== "3" ? true : false}
                                    value={this.state.parte1B.indirizzoCentro}
                                    placeholder={t("SchedaSpecialeTbcPolmonare.indirizzo")}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={"col-lg-6"}>
                            <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                                {t("SchedaSpecialeTbcPolmonare.dataInizio")}
                                <span className={styles.mandatoryColor}>*</span>
                            </p>
                        </div>
                        <div className={"col-lg-4"}>
                            <Calendar id={"dataInizioTerapia"}
                                      value={this.state.parte1B.dataInizioTerapia}
                                      field={"dataInizioTerapia"}
                                      onChange={this.riceviValore}
                                      newCalendar={true}
                                      errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                          t("SchedaSpecialeTbcPolmonare.dataInizio"))}
                                      error={(!this.state.parte1B.dataInizioTerapia) ? false :
                                          Utils.isDateInValid(Utils.transformDateForBackend(this.state.parte1B.dataInizioTerapia), "-")}
                            />
                        </div>

                    </div>
                    <div style={{marginTop: "1rem"}}>
                        <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                            {t("SchedaSpecialeTbcPolmonare.storiaMalattia")}
                            <span className={styles.mandatoryColor}>*</span>
                            <span style={{color: "black", fontWeight: "normal"}}>
                            {t("SchedaSpecialeTbcPolmonare.selSoloUnaVoce")}
                        </span>
                        </p>
                        <RadioButton id={"nuovoCaso"}
                                     name={"storiaMalattia"} label={t("SchedaSpecialeTbcPolmonare.nuovoCaso")}
                                     value={"1"}
                                     newRadio={true}
                                     onClick={this.riceviValore}
                                     style={{color: "black"}}
                                     checked={this.state.parte1B.storiaMalattia === "1"}/>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"recidiva"}
                                             required={this.state.parte1B.storiaMalattia === "2"}
                                             name={"storiaMalattia"} label={t("SchedaSpecialeTbcPolmonare.recidiva")}
                                             value={"2"} onClick={this.riceviValore}
                                             newRadio={true}
                                             style={{color: "black"}}
                                             checked={this.state.parte1B.storiaMalattia === "2"}/>
                            </div>
                            <div className={"col-lg-3"}>
                                <RadioButton id={"pazienteGuarito"}
                                             name={"recidiva"} label={t("SchedaSpecialeTbcPolmonare.pazienteGuarito")}
                                             value={"1"} onClick={this.riceviValore}
                                             newRadio={true}
                                             disabled={this.state.parte1B.storiaMalattia !== "2" ? true : false}
                                             style={{color: "black"}}
                                             checked={this.state.parte1B.recidiva === "1"}/>
                            </div>
                            <div className={"col-lg-3"}>
                                <RadioButton id={"trattamentoCompletato"}
                                             name={"recidiva"}
                                             label={t("SchedaSpecialeTbcPolmonare.trattamentoCompletato")}
                                             value={"2"} onClick={this.riceviValore}
                                             newRadio={true}
                                             disabled={this.state.parte1B.storiaMalattia !== "2" ? true : false}
                                             style={{color: "black"}}
                                             checked={this.state.parte1B.recidiva === "2"}/>
                            </div>
                        </div>

                        <RadioButton id={"altro"}
                                     name={"storiaMalattia"} label={t("SchedaSpecialeTbcPolmonare.altro")}
                                     value={"3"} onClick={this.riceviValore}
                                     newRadio={true}
                                     style={{color: "black"}}
                                     checked={this.state.parte1B.storiaMalattia === "3"}/>
                    </div>
                </div>
            </div>
        )

        return (
            <div>
                {parte1B}
            </div>
        );
    }
}

export default withTranslation('common')(Parte1B)
